import { computed, ref } from 'vue';
import { type CurrentInstance } from '@/common/stores/instance';
import type { BreadCrumbMenuInfo, BreadCrumbMode } from '../breadCrumbs.types';
import { getLinkWrapperTop } from './breadCrumbElementLink.setup';

export interface Props {
  menuInfo?: BreadCrumbMenuInfo;
  mode?: BreadCrumbMode;
  currentInstance?: CurrentInstance;
  currentMultiViewExpandedMenu?: string;
}

export interface Emit {
  (
    e: 'instance-multi-view-expand',
    menu?: BreadCrumbMenuInfo,
    pos?: {
      top: number;
    },
  ): void;
  (e: 'link-clicked', menu?: BreadCrumbMenuInfo): void;
}

const useInstanceElement = (props: Props, emit: Emit) => {
  const currentMultiViewExpandedMenu = ref<string | undefined>(props.currentMultiViewExpandedMenu);

  const multiViewExpand = (menu: BreadCrumbMenuInfo, evt: MouseEvent) => {
    if (currentMultiViewExpandedMenu.value === menu.value) {
      currentMultiViewExpandedMenu.value = undefined;
      emit('instance-multi-view-expand', undefined, undefined);
      return;
    }
    currentMultiViewExpandedMenu.value = menu.value;

    const top = getLinkWrapperTop(evt);
    const position = {
      top,
    };

    emit('instance-multi-view-expand', menu, position);
  };

  return {
    multiViewExpand,
    currentMultiViewExpandedMenu,
  };
};

export const setup = (props: Props, emit: Emit) => {
  const singleMenu = computed(() =>
    props.mode === 'instance'
      ? // @ts-expect-error TODO: FIXME
        props.menuInfo?.children?.filter((m) => m.dbType !== 'redis')
      : props.menuInfo?.children?.filter((m) => !m.children?.length),
  );

  const nestedMenu = computed(() => {
    const middleMenu =
      props.mode === 'instance' ? [] : props.menuInfo?.children?.filter((m) => m.children?.length);

    return middleMenu || props.menuInfo?.subMenuList;
  });

  const onLinkClick = (menu: BreadCrumbMenuInfo) => {
    if (menu.disabled) {
      return;
    }

    emit('link-clicked', menu);
  };

  const shouldTitleRendered = (title: string) => {
    return title !== props.menuInfo?.text;
  };

  return {
    singleMenu,
    nestedMenu,
    onLinkClick,
    shouldTitleRendered,
    ...useInstanceElement(props, emit),
  };
};
